import { Box, Text, TextButton } from '@wix/design-system';
import { Refresh } from '@wix/wix-ui-icons-common/lazy';
import React from 'react';
import { DomainSearchGateModule } from '../../../../module/domainSearchGate.module';
export const WhoisInlineError = _ref => {
  let subtitle = _ref.subtitle,
    onRetry = _ref.onRetry;
  const _DomainSearchGateModu = DomainSearchGateModule.internals.useTranslations(),
    t = _DomainSearchGateModu.t,
    Trans = _DomainSearchGateModu.Trans;
  return /*#__PURE__*/React.createElement(Box, {
    direction: "vertical",
    gap: "SP4",
    padding: "SP6"
  }, /*#__PURE__*/React.createElement(Text, {
    size: "medium",
    weight: "bold"
  }, t('domain_search_gate.whois_results.error.info_card.title')), /*#__PURE__*/React.createElement(Text, {
    size: "small",
    secondary: true
  }, subtitle || /*#__PURE__*/React.createElement(Trans, {
    i18nKey: "domain_search_gate.whois_results.error.card.description",
    components: [/*#__PURE__*/React.createElement("br", null)]
  })), /*#__PURE__*/React.createElement(TextButton, {
    prefixIcon: /*#__PURE__*/React.createElement(Refresh, null),
    onClick: onRetry
  }, t('domain_search_gate.whois_results.error.card.try_again.cta')));
};
//# sourceMappingURL=WhoisInlineError.js.map